// extracted by mini-css-extract-plugin
module.exports = {"cardColumns":"styles-module__cardColumns___1TR1U"};